module.exports = __webpack_public_path__ + "img/retrospect-inspect-small.cb4a3d7b.jpg";